import React, { useCallback, useEffect, useState, useRef } from "react";
import { ReactComponent as ExamIcon } from "../../../images/examimage/examicon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import QuestionHead from "../../../CustomComponent/QuestionHead";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import TableView from "../../../CustomComponent/TableView";
import ResultHead from "../../../CustomComponent/ResultHead";
import { ReactComponent as ResultIcon } from "../../../images/questionimage/resulticon.svg";
import ExamLogo from "../../../images/questionimage/examlogo.jpg";
import { useParams, useLocation } from "react-router-dom";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { ReactComponent as LoginIcon } from "../../../images/DashboardLoginImage/Student login icon.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import SendIcon from "@material-ui/icons/Send";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Button, Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Loader from "../../../CustomComponent/Loader";
import socket from "../../../socket/socket";
import { debounce } from "lodash";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";

function ActivityLogs() {
  const classes = useStyles();
  const { rowId } = useParams();
  const location = useLocation();
  const desiredPath = `/admin/activitylogs/${rowId}`;
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const examDetails = location.state;
  const [rowCount, setRowCount] = useState("");

  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [changeStatus, setChangeStatus] = useState([]);

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };

  // const [examDetails, setExamDetails] = useState({
  //   examName: "",
  //   courseName: "",
  //   batchName: "",
  //   subjectNames: "",
  //   examImage: "",
  // });

  //   useEffect(() => {
  //     const fetchExamData = async () => {
  //       try {
  //         const response = await axios.get(
  //           `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${decryptedToken}`,
  //             },
  //           }
  //         );

  //         const exam = response.data.exam;
  //         const subjectNames = exam.subjects
  //           .map((sub) => sub.subject_name)
  //           .join(", ");

  // console.log('exam response',response.data)

  //         setExamDetails({
  //           examName: exam.exam_name,
  //           courseName: exam.course.map((c)=>c?.course_name).join(', '),
  //           batchName: exam.batch.map((c)=>c?.batch_name).join(', '),
  //           subjectNames: subjectNames,
  //           centers: exam.center,
  //           examImage: exam.image_url,
  //         });
  //       } catch (error) {
  //         console.error("Error fetching exam data: ", error);
  //       }
  //     };

  //     fetchExamData();
  //   }, [rowId, decryptedToken]);

  const formatDate = (dateString) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const [givingExamData, setGivingExamData] = useState([]);
  const [filteredGivingExamData, setFilteredGivingExamData] = useState([]);

  // useEffect(() => {
  //   setFilteredGivingExamData(givingExamData);
  // }, [givingExamData]);

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearchQuery(value.trim());
    }, 500),
    []
  );

  //   const fetchExamLogs = async (
  //     rowId,
  //     pageNumber,
  //     size,
  //     branch,
  //     center,
  //     branchStatus,
  //     search
  //   ) => {
  //     if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;
  //     const status = branchStatus === "All" ? "" : branchStatus;

  //     try {
  //       const response = await axios.get(
  //         // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/giving/${rowId}`,
  //         `${
  //           process.env.REACT_APP_API_BASE_URL
  //         }/v1/b2b/exam/giving/pagination/${rowId}?page=${
  //           pageNumber + 1
  //         }&limit=${size}&branchSearch=${branch}&centerSearch=${center}&statusSearch=${status}&search=${search}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${decryptedToken}`,
  //           },
  //         }
  //       );

  //       setRowCount(response?.data?.total_count);
  //       let learners = response.data.learners;
  //       const startIndex = pageNumber * size;

  //       const statusData = learners.map((learner) => ({
  //         userId: Number(learner.user_id),
  //         examId: Number(learner.exam_id),
  //         status:
  //           learner.status.charAt(0).toUpperCase() + learner.status.slice(1),
  //       }));

  //       setChangeStatus(statusData);
  // console.log('learners',learners)

  //       let formattedData = learners.map((learner, index) => ({
  //         id: learner.user_id,
  //         srno: startIndex + index + 1,
  //         roll_number: learner.roll_number,
  //         name: learner.learner_name,
  //         phone: learner.phone,
  //         email: learner.email,
  //         center_code: `${learner.center_code} - ${learner.center_name}`,
  //         batch_code:learner?.batch?.batch_name||'N/A',
  //         center_code2:
  //           learner.center_code2 && learner.center_name2
  //             ? `${learner.center_code2} - ${learner.center_name2}`
  //             : "N/A",
  //         status: capitalizeFirstLetter(learner.status),
  //         registrationData: formatDate(learner.registration_date),
  //         remaining_time: `${
  //           learner.remaining_time === "00:00:00"
  //             ? "Time Lapse"
  //             : learner.remaining_time
  //         }`,
  //       }));

  //       // Apply dropdown Center filter
  //       // if (centerFilterData.toLowerCase() == "All Center") {
  //       //   formattedData = formattedData.filter(
  //       //     (learner) =>
  //       //       learner.center_code.toLowerCase() === centerFilterData.toLowerCase()
  //       //   );
  //       // }

  //       // // Apply dropdown filter
  //       // if (filterData.toLowerCase() == "All") {
  //       //   formattedData = formattedData.filter(
  //       //     (learner) => learner.status.toLowerCase() === filterData.toLowerCase()
  //       //   );
  //       // }

  //       // Apply search filter only if there is a search query
  //       // if (searchQuery) {
  //       //   formattedData = formattedData.filter((learner) =>
  //       //     learner.name.toLowerCase().includes(searchQuery.toLowerCase())
  //       //   );
  //       // }
  //       console.log("formattedData", formattedData);
  //       setFilteredGivingExamData(formattedData);
  //     } catch (error) {
  //       console.error("Error fetching exam data: ", error);
  //     }
  //   };
  //   const hasFetchedData = useRef(false);

  //   useEffect(() => {
  //     if (!rowId || !pageSize) return;

  //     const shouldFetch =
  //       location.pathname === desiredPath &&
  //       typeof onPage === "number" &&
  //       typeof pageSize === "number" &&
  //       centerFilterData !== undefined &&
  //       filterData !== undefined;

  //     if (!shouldFetch) return;

  //     fetchDashboardExamData(
  //       rowId,
  //       onPage,
  //       pageSize,
  //       centerFilterData,
  //       centerFilterData2,
  //       filterData,
  //       searchQuery
  //     );
  //   }, [
  //     rowId,
  //     onPage,
  //     pageSize,
  //     centerFilterData,
  //     filterData,
  //     searchQuery,
  //     centerFilterData2,
  //   ]);


 const fetchExamLogs = async (exam_id, user_id, pageSize, onPage) => {
try {
  const apiPage = onPage + 1;

  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/logs/get/all`,
    {
      params: {
        exam_id,
        user_id,
        page: apiPage,
        limit: pageSize,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const data = response.data;

  const startIndex = onPage * pageSize;

  const newData = data.logs.map((d, i) => ({
    ...d,
    srno: startIndex + i + 1,
  }));

  setFilteredGivingExamData(newData);
  setRowCount(data?.total_count);

  return data;
} catch (error) {
  console.error("Error fetching exam logs:", error);
  return null;
}
};


  useEffect(() => {
    if (examDetails?.rowId && rowId) {
      fetchExamLogs(examDetails.rowId, rowId, pageSize, onPage);
    }
  }, [examDetails?.rowId, rowId, pageSize, onPage]);

  const Heading = [
    {
      id: 1,
      // logo: examDetails.examImage,
      path: `/admin/examdashboard/${examDetails.rowId}`,
      headings: [
        {
          id: 11,
          label: "Name",
          content: examDetails.name,
        },
        {
          id: 12,
          label: "Roll Number",
          content: examDetails.roll_number,
        },
        {
          id: 13,
          label: "Exam Name",
          content: examDetails.exam_name,
        },
        // {
        //   id: 14,
        //   label: "Batch",
        //   content: examDetails.batchName,
        // },
      ],
    },
  ];

  const givingcolumns = [
    {
      field: "srno",
      headerName: "Sr.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "date_time",
      headerName: "Date & Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "ip",
      headerName: "IP",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 300,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "phone",
    //   headerName: "Phone",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "activity",
      headerName: "Activity",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
  ];

  const GivingExam = [
    {
      id: 1,
      pageicon: <ResultIcon />,
      mainheading: "Live Exam Dashboard",
      searchlabel: "Search Learner Name",
      placeholder: "Search By Class",
      style: "viewtable",
      relogin: "true",
      submit: "true",
      centerfilter: "true",
      filter: "true",
      height: "maxh67",
      report1: "Export File",
      refresh: "Refresh",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  console.log('pageSize',pageSize,'rowCount',rowCount)
  
  const [scheduledExamDate, setScheduledExamDate] = useState("");

  useEffect(() => {
    const examId = examDetails?.rowId;
    if (examId && decryptedToken) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${examId}`, {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        })
        .then((res) => {
          const exam = res.data?.exam;
          const dateVal = exam?.start_date || exam?.exam_date || exam?.date;
          if (dateVal) {
            setScheduledExamDate(dateVal);
          }
        })
        .catch((err) => console.error("Error fetching exam date:", err));
    }
  }, [examDetails?.rowId, decryptedToken]);

  const getFormattedDate = (dateObj) => {
    const d = dateObj && !isNaN(new Date(dateObj)) ? new Date(dateObj) : new Date();
    const day = String(d.getDate()).padStart(2, "0");
    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const learnerName = (examDetails?.name || "Learner").trim().replace(/\s+/g, "_");
  const rollNo = examDetails?.roll_number || "N/A";
  const rawExamDate = examDetails?.exam_date || examDetails?.start_date || examDetails?.date || scheduledExamDate;
  const examDateStr = getFormattedDate(rawExamDate);

  const dynamicExportFileName = `CANDIDATE_ACTIONS_LOG_of_${learnerName}_Roll_No_${rollNo}_Exam_Date-${examDateStr}.csv`;

  const Heading2 = [
    // examDetails?.rowId && rowId
    {
      id: 1,
      // inputplaceholder: "Search cource name",
      export: "yes",
      exportFileName: dynamicExportFileName,
      exportApiUrl: `${process.env.REACT_APP_API_BASE_URL}/logs/export/student?exam_id=${examDetails?.rowId}&user_id=${rowId}`,
    },
  ];

  const [loaderOpen, setLoaderOpen] = useState(false);
  return (
    <>
      <ToastContainer />
      <div>
        <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
          <QuestionHead Heading={Heading} />
          <TableViewSearch Heading={Heading2} />
          <Loader loaderOpen={loaderOpen} />
          {/* <ResultHead
            fetchDashboardExamData={fetchDashboardExamData}
            Heading={GivingExam}
            onSearch={onSearchGivingExam}
            centerFilterData={centerFilterData}
            setCenterFilterData={setCenterFilterData}
            centerFilterData2={centerFilterData2}
            setCenterFilterData2={setCenterFilterData2}
            filterData={filterData}
            setFilterData={setFilterData}
            rowId={rowId}
            decryptedToken={decryptedToken}
            dashboard={true}
            centerDeatil={examDetails.centers}
            centerDeatil2={centerDeatil2}
            setLoaderOpen={setLoaderOpen}
            onPage={onPage}
            pageSize={pageSize}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            setChangeStatus={setChangeStatus}
          /> */}

          <div
            className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px} `}
          >
            <TableView
              columns={givingcolumns}
              rows={filteredGivingExamData.map((row) => ({
                ...row,
                className: classes.tableRow,
              }))}
              Heading={GivingExam}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default ActivityLogs;
